import i18n from '@/plugins/i18n';
const queryPerformanceTableHeadersCouchbase = () => [
  {
    key: 'name',
    name: i18n.global.t('dbm.query.queryName'),
    routable: false,
    width: '50%',
  },
  {
    key: 'count',
    width: '15%',
    name: i18n.global.t('dbm.query.totalExicution'),
    routable: false,
    sortable: true,
  },

  {
    key: 'value',
    name: i18n.global.t('dbm.query.executionTime'),
    routable: false,
    width: '20%',
    sortable: true,
  },
  {
    key: 'timestamp',
    name: i18n.global.t('dbm.query.timestamp'),
    routable: false,
    width: '15%',
    sortable: true,
  },
];
export const QueryThresholdValues = [
  { key: '1', label: '1ms' },
  { key: '100', label: '100ms' },
  { key: '200', label: '200ms' },
  { key: '500', label: '500ms' },
  { key: '1000', label: '1s' },
  { key: '3000', label: '3s' },
  { key: '5000', label: '5s' },
  { key: '10000', label: '10s' },
];

export { queryPerformanceTableHeadersCouchbase };
